module.exports = __webpack_public_path__ + "static/media/WBTC.7c448f4b.svg";